module.exports = __webpack_public_path__ + "static/media/completaperfil.6cff908e.svg";